export default __webpack_public_path__ + "static/media/profile-user.2ab6e483.svg";